var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./OpenTerms.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-01811410!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OpenTerms.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Term/Open/OpenTerms.vue
// module id = 656
// module chunks = 0